export const internalMessageCanEdit = {
  Properties: {
    Name: 'FrontPageInternalMessage',
    IsEditable: true,
    Value:
      '<h2 style="text-align: center;"><strong>TimeLog Project&nbsp;</strong></h2><p><img style="display: block; margin-left: auto; margin-right: auto;" src="http://www.timelog.com/media/754628/star_color_en.jpg" alt="" width="254" height="254" /></p>',
  },
  Links: [{ Href: 'http://localhost/tlp/api/v2/settings/frontpage-internal-message', Rel: 'self' }],
};
